<script lang="ts" setup>
import { computed, type HTMLAttributes } from "vue";
import type { StepperRootEmits, StepperRootProps } from "reka-ui";
import { StepperRoot, useForwardPropsEmits } from "reka-ui";
import { twMerge } from "tailwind-merge";

const props = defineProps<StepperRootProps & { class?: HTMLAttributes["class"] }>();
const emits = defineEmits<StepperRootEmits>();

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <StepperRoot v-slot="slotProps" v-bind="forwarded" :class="twMerge('flex gap-2', props.class)">
    <slot v-bind="slotProps" />
  </StepperRoot>
</template>
